import React, { useState, useContext, useEffect} from "react";

import { AppContext } from "../../AppContext";

import DateUtil from "../../common/dateUtil";
import { fetchCall } from "../../common/FetchHelpers";

import ObaManualFormComp from "./manual/ObaManualFormComp";
import ObaSurveyFormComp from "./survey/ObaSurveyFormComp";
import ObaPreviewComp from "./ObaPreviewComp";

const ObaEditorComp = (props) => {

  const reqUrl = "api/oba/create";

  let submittedFor = '';
 
  const emptyFormData = {   
    id:-1,
    status:"",
    businessName : "",
    businessType : "",
    businessDesc : "",
    businessAddress : "",
    yearlyIncome : "",
    compensationMethod : "",
    engagementTime : "",
    businessStructure : "",
    activityStartDate : "",
    isBusinessCustody:"",
    businessCustody : "",
    attachment:null,

    isDba : "",
    isDbaHomeState:"",
    titlePosition:"",
    businessOrganizationName:"",

    isClientOwnSecurity:"",
    clientAccount:"",
    rdoPartnerType:"",
    partnerType:"",
    businessRelations:[],
    otherBusinessRelation:"",
    businessDuty:"",
    businessUrl:"",
    isInvestSecurity:"",
    isFundraising:"",
    fundraisingDesc:"",
    isInvestmentRep:"",
    isEngageMoreThan10Percent:"",
    isIncomeMoreThan10Percent:"",
    isSolicitedInvest:"",
    solicitedInvestors:[{investorName:"",investorRelation:"",investmentAmount:"",investmentDate:"",involvementType:""}],
    isActivityInvolve:"",
    activityInvolvedPeople:[{name:"",accountNumbers:"",involvementType:""}],
    requiresTwoSignCheck:"",
    insuranceCovered:"",
    otherInfo:"",
    complyAudit:"",
    complyFee:"",
    complySolicitation:""
  }

  const [appContext, setAppContext] = useContext(AppContext);
  
  const [showEditor, setShowEditor] = useState(true);
  const [showPreview, setShowPreview] = useState(false);
  
  const [formData, updateFormData] = useState(props.formData);
    
  //#region manualForms
  const handleChange = (e) => {
    if(e.target.name === 'submittedFor') {
      updateFormData({...formData, [e.target.name]: e.target.value, submittedForLabel: e.target.label});
    } else{
      const value = (e.target.files && e.target.files[0])?e.target.files[0]:((e.target.type === "checkbox")?e.target.checked:e.target.value);
      updateFormData({...formData,[e.target.name]:value});
    }
  };

  const handleDateChange = (date) => {
    console.log(formData);
    updateFormData({
      ...formData,
      activityStartDate: date
    });
  };

  const onUserSelected = (e)=>{
    submittedFor = e.target.value;
  };

  const handleSaveClick = () => {

      updateFormData({
        ...formData,
        solicitedInvestors,
        activityInvolvedPeople

      });

      setDetailConfig(defaultConfig);
      setShowEditor(false);
      setShowPreview(true);
    
  };

  const handleSubmit = () => {
    
    let activityStartDate = DateUtil.toStrDate(formData.activityStartDate);

    const fData = new FormData();

    fData.append("id",formData.id);
    fData.append("status",formData.status);
    fData.append("businessName",formData.businessName);
    fData.append("businessType",formData.businessType);
    fData.append("businessDesc",formData.businessDesc);
    fData.append("businessAddress",formData.businessAddress);
    fData.append("yearlyIncome",formData.yearlyIncome);
    fData.append("compensationMethod",formData.compensationMethod);
    fData.append("engagementTime",formData.engagementTime);
    fData.append("businessStructure",formData.businessStructure);
    fData.append("activityStartDate",activityStartDate);
    fData.append("businessCustody",formData.businessCustody);
    fData.append("file",formData.attachment);
        
    if(formData.submittedFor)
      fData.append("submittedFor",formData.submittedFor);

    console.log(fData);
    createObaRequest(fData, props.editorMode === "NEW");
  };

  const handleClosePreview = () => {
    setShowEditor(true);
    setShowPreview(false);
  };


  const handleAddAnother = () => {
    setDetailConfig(defaultConfig);
    updateFormData({...emptyFormData, template: props.formData.template});
    handleClosePreview();
  };



  const [solicitedInvestors,setSolicitedInvestors] = useState(props.formData.solicitedInvestors);

  const solicitedInvestorAdd = ()=>{
    setSolicitedInvestors(solicitedInvestors=>[...solicitedInvestors,{investorName:'',investorRelation:'',investmentAmount:'',investmentDate:"",involvementType:""}])
  };

  const solicitedInvestorRemove = (idx)=>{
    if(solicitedInvestors.length>1){
        const temp = [...solicitedInvestors];
        temp.splice(idx, 1);
        setSolicitedInvestors(temp);
    }else{
      setSolicitedInvestors([{investorName:'',investorRelation:'',investmentAmount:'',investmentDate:"",involvementType:""}]);
    }
  };

  const solicitedInvestorChanged = (e,idx)=>{
      let newArr = [...solicitedInvestors];
      newArr[idx] = {...newArr[idx], [e.target.name]:e.target.value};
      setSolicitedInvestors(newArr);
  }

  const [activityInvolvedPeople,setActivityInvolvedPeople] = useState(props.formData.activityInvolvedPeople);

  const activityInvolvedPeopleAdd = ()=>{
    setActivityInvolvedPeople(activityInvolvedPeople=>[...activityInvolvedPeople,{name:'',accountNumbers:'',involvementType:""}])
  };

  const activityInvolvedPeopleRemove = (idx)=>{
    if(activityInvolvedPeople.length>1){
        const temp = [...activityInvolvedPeople];
        temp.splice(idx, 1);
        setActivityInvolvedPeople(temp);
    }else{
      setActivityInvolvedPeople([{name:'',accountNumbers:'',involvementType:""}]);
    }
  };

  const activityInvolvedPeopleChanged = (e,idx)=>{
    let newArr = [...activityInvolvedPeople];
    newArr[idx] = {...newArr[idx], [e.target.name]:e.target.value};
    setActivityInvolvedPeople(newArr);
  }

  //#endregion

  const handleSubmitSurvey = (item) => {
    const fData = new FormData();
    fData.append("id",item.id);
    fData.append("templateStr",item.template.templateStr);
    fData.append("formData",JSON.stringify(item.formData));
    fData.append("businessName",item.formData.businessName);
    fData.append("businessType",item.formData.businessType);
    fData.append("businessDesc", item.formData.outsideActivities);
    
    //fData.append("submittedFor",submittedFor?submittedFor:null);
    
    if(submittedFor)
      fData.append("submittedFor",submittedFor);
    
    if (item.changes && item.changes.length>0) {
      fData.append("changes", JSON.stringify(item.changes));
    }
    
    updateFormData(item);
    createObaRequest(fData, false);
  }

  const createObaRequest = (fData, reloadSummary) => {
    const reqOptions = {
      method: "POST",
      body: fData
    };
    
    fetchCall(reqUrl, reqOptions)
      .then((json) => {
      if(reloadSummary){
        setAppContext({ ...appContext, reloadSummary: true });
      }
      setDetailConfig({
        ...detailConfig,
        detailMode:"POSTREVIEW",
        title: "Request submitted",
        status: {
          state: "success",
          message: "Request successfully submitted",
        },
        btnOk: {
          label: "Add Another request",
          handler: handleAddAnother
        },
        btnCancel: {
          label: "Close",
          handler: props.handleClose,
        },
      });
    })
    .catch((err) => {
        setShowEditor(false);
        setShowPreview(false);
    });
  }

  const defaultConfig = {
    editorMode:props.editorMode,
    detailMode:"PREVIEW",
    title: "Review your request before submitting",
    status: {
      state: "",
      message: "",
    },
    btnOk: {
      label: "Submit",
      handler: handleSubmit,
    },
    btnCancel: {
      label: "Edit Before Submit",
      handler: handleClosePreview,
    },
  };
  const [detailConfig, setDetailConfig] = useState(defaultConfig);

  let formComp;
  const isTemplatedForm = () => {
      return props.formData.template != null && props.formData.template !== "";
  }

  if (isTemplatedForm()) {
    formComp = <ObaSurveyFormComp
                editorMode={props.editorMode} 
                data={formData}
                config={detailConfig}
                onUserSelected={onUserSelected}
                handleCancel={props.handleClose}
                handleSubmitSurvey={handleSubmitSurvey} />
  } else {
    formComp = <ObaManualFormComp
                editorMode={props.editorMode}
                data={formData}
                handleChange={handleChange}
                handleDateChange={handleDateChange}
                handleSaveClick={handleSaveClick}
                handleCancel={props.handleClose}

                solicitedInvestors={solicitedInvestors}
                solicitedInvestorAdd={solicitedInvestorAdd}
                solicitedInvestorRemove={solicitedInvestorRemove}
                solicitedInvestorChanged={solicitedInvestorChanged} 

                activityInvolvedPeople={activityInvolvedPeople}
                activityInvolvedPeopleAdd={activityInvolvedPeopleAdd}
                activityInvolvedPeopleRemove={activityInvolvedPeopleRemove}
                activityInvolvedPeopleChanged={activityInvolvedPeopleChanged} 
              />;
  }

  return (
    <>
      {showPreview && (
        <ObaPreviewComp
          config={detailConfig}
          data={formData}
        />
      )}

      {showEditor && (formComp)}
    </>
  );
};
export default ObaEditorComp;
